import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import TabNavigation from '../../components/ui/TabNavigation';
import PrivacyToggle from '../../components/ui/PrivacyToggle';
import QuickActionFloat from '../../components/ui/QuickActionFloat';
import CoupleProfileCard from './components/CoupleProfileCard';
import MetricsPanel from './components/MetricsPanel';
import QuickActionTiles from './components/QuickActionTiles';
import InsightsPanel from './components/InsightsPanel';
import UpcomingActivities from './components/UpcomingActivities';
import EditProfileModal from './components/EditProfileModal';

const SharedProfileDashboard = () => {
  const navigate = useNavigate();
  const { user, loading } = useAuth();
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  // Authentication guard
  useEffect(() => {
    if (!loading && !user) {
      navigate('/login');
    }
  }, [user, loading, navigate]);

  // Show loading state while checking authentication
  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-center">
          <div className="w-12 h-12 border-4 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }

  // Don't render dashboard if not authenticated
  if (!user) {
    return null;
  }

  const coupleData = {
    partner1: {
      name: "",
      avatar: "",
      avatarAlt: ""
    },
    partner2: {
      name: "",
      avatar: "",
      avatarAlt: ""
    },
    relationshipStart: "",
    location: "",
    relationshipGoals: [],
    recentActivity: ""
  };

  const metrics = {
    encountersThisMonth: 0,
    encounterTrend: 0,
    compatibilityScore: 0,
    compatibilityTrend: 0,
    upcomingScheduled: 0,
    currentStreak: 0
  };

  const notifications = {
    schedule: 0,
    mood: 0,
    communication: 0,
    history: 0
  };

  const insights = [];

  const upcomingActivities = [];

  useEffect(() => {
    const interval = setInterval(() => {
      setRefreshKey((prev) => prev + 1);
    }, 60000);

    return () => clearInterval(interval);
  }, []);

  const handleEditProfile = () => {
    setIsEditModalOpen(true);
  };

  const handleSaveProfile = (formData) => {
    console.log('Profile updated:', formData);
  };

  return (
    <div className="min-h-screen bg-background">
      <TabNavigation />
      <PrivacyToggle />
      <QuickActionFloat />
      <main className="pt-[60px] pb-20 lg:pb-8 px-4 md:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto space-y-6 md:space-y-8 lg:space-y-10 py-6 md:py-8">
          <div className="space-y-2">
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-semibold text-foreground">
              Welcome Back
            </h1>
            <p className="text-sm md:text-base lg:text-lg text-muted-foreground">
              Your relationship dashboard for {new Date()?.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' })}
            </p>
          </div>

          <CoupleProfileCard
            coupleData={coupleData}
            onEditProfile={handleEditProfile} />


          <MetricsPanel metrics={metrics} />

          <QuickActionTiles notifications={notifications} />

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8">
            <InsightsPanel insights={insights} />
            <UpcomingActivities activities={upcomingActivities} />
          </div>
        </div>
      </main>
      <EditProfileModal
        isOpen={isEditModalOpen}
        onClose={() => setIsEditModalOpen(false)}
        coupleData={coupleData}
        onSave={handleSaveProfile} />

    </div>);

};

export default SharedProfileDashboard;